// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.e0Llnw6f7nSjEUKtKIEI {
  font-style: italic;
}

.FupTf1GfnUO5Caertid1{
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/plugins/wysiwyg/admin/src/components/GlossaryTermsModal/components/SearchInput/styledComponents/SearchInput.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb","sourcesContent":[".textCursive {\n  font-style: italic;\n}\n\n.w100{\n  width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textCursive": `e0Llnw6f7nSjEUKtKIEI`,
	"w100": `FupTf1GfnUO5Caertid1`
};
export default ___CSS_LOADER_EXPORT___;
